
export const defaultPaymentMethods = () => {
    return {
        code: null,
        description: null,
        accounting_account_id: null,
        commission_percentage: 0.0,
        user_id: null,
        online_payment: 0,
        check_number: 0,
        expiration_date: 0,
        authorization_number: 0,
        logo: '',
        rte_fte_percentage: 0.0,
        rte_iva_percentage: 0.0,
        rte_ica_percentage: 0.0,
        entity_id: null,
        commission_account_id: null,
        rte_fte_account_id: null,
        rte_iva_account_id: null,
        rte_ica_account_id: null,
        code_dian_id: null,
        validate_customer_balance: false,
        type_id: null,
        account_group: null,
        wallet_type_id: null,
    };
};


export default {

    selectedPaymentMethods: defaultPaymentMethods(),
    params: {
        perPage: 50,
        page: 1,
        type_id: null,
        filter: null
    },
    disabledInputs: false,
    actionForm:'create',
    accounts:[],
    contacts:[],
    logos:[
        {
            code : 'Billetes',
            icon :'ti-money'
        },
        {
            code : 'Tarjeta',
            icon :'ti-credit-card'
        },
        {
            code : 'Transferencia',
            icon :'ti-tablet'
        },
        {
            code : 'Cheque',
            icon :'ti-receipt'
        },
        {
            code : 'Nequi',
            icon :'ti-nequi'
        },
        {
            code : 'Daviplata',
            icon :'ti-daviplata'
        },
        {
            code : 'Tpaga',
            icon :'ti-tpaga'
        },
        {
            code : 'A Credito',
            icon :'ti-more'
        },
        ],
    paymentMethods:[],
    dian_codes:[],
}



// WEBPACK FOOTER //
// ./src/modules/payment-methods/state.js